export default "__VITE_ASSET__3063f491__"